import { adminRoutes } from '@bettermode/domain/routes/web/admin'
import { T } from '@tribeplatform/react-components/i18n'
import { useRouter } from '@tribeplatform/react-sdk'
import { SectionHeader } from '@tribeplatform/react-ui-kit/SectionHeader'
import { Sidebar } from '@tribeplatform/react-ui-kit/Sidebar'

import { SidebarBackButton } from '../../AdminMenu/SidebarBackButton.js'
import { AppearanceLogos } from '../../Editor/Appearance/AppearanceLogos.js'

export function AppearanceLogosRoute() {
  return (
    <Sidebar size="lg">
      <Sidebar.Content className="space-y-4">
        <SidebarBackButton href={adminRoutes.design.appearance.root} />
        <SectionHeader
          title={<T id="Generics.Logos" defaultMessage="Logos" />}
        />
        <AppearanceLogos />
      </Sidebar.Content>
    </Sidebar>
  )
}

export function AppearanceLogosBreadCrumb() {
  const { Link } = useRouter()
  return (
    <Link href={adminRoutes.design.appearance.logos}>
      <T id="Generics.Logos" defaultMessage="Logos" />
    </Link>
  )
}
